import { defaultLanguage, listLanguage } from '../../configs/LanguageConfig';
import { getQueryParams } from './Common';

export const KEY_LANGUAGE = 'language';

export const changeUILanguage = lang => {
  if (lang === listLanguage.vi) {
    document.body.classList.add(listLanguage.vi);
  } else {
    document.body.classList.remove(listLanguage.vi);
  }
};

export const getLanguage = () => {
  let lang =
    getQueryParams('language') ||
    localStorage.getItem(KEY_LANGUAGE) ||
    defaultLanguage;

  if (['vi', 'en'].indexOf(lang) < 0) {
    lang = defaultLanguage;
  }

  return lang;
};

export const saveLanguage = lang => {
  localStorage.setItem(KEY_LANGUAGE, lang);
};
